const {
	_checkKeystorePass,
	_add0x,
	_remove0x,
	_getPersonalSignInitials,
	_getBatchPersonalSignInitials,
	_getPersonalSignInitialsByPrivateKey,
	_getBatchPersonalSignInitialsByPrivateKey,
	_generateCredentials,
	_getValidatorLifecycleStatus,
	_formDepositDataRoot,
	_getLastDepositIndex,
	_getDETHBalanceInIndex,
	_getSLOTBalanceInVault,
	_getsETHAddress,
	_getsETHBalance,
	_getGenericERC20WalletBalance,
	_currentSlashedAmountOfSLOTForKnot,
	_specialExitFee,
	_calculateExitFee,
	_getNumberOfCollateralisedSlotOwnersForKnot,
	_getStakehouseRedemptionRate,
	_getStakehouseExchangeRate,
	_getStakehouseSETHRedemptionThreshold,
	_getTotalUserCollateralisedSETHBalanceInHouse,
	_totalFundsInKNOTQueue,
	_associatedIndexIdForKnot,
	_rageQuitChecks,
	_indexIdToOwner,
	_isBalanceLower,
	_dETHToSavETH,
	_savETHToDETH,
	_dETHRewardsMintedForKNOT,
	_dETHRequiredForIsolation,
	_savETHRequiredForIsolation,
	_getKNOTNonce,
	_getLastKnownReportForKNOT,
	_updateSavETHIndexName,
	_topUpSlashedSlot,
	_topUpSlashedSlotWithOneEth,
	_topUpKNOT,
	_topUpKNOTWithOneEth,
	_dETHMetadata,
	_getStakehouse,
	_isPartOfStakehouse
} = require('../logic/utils');

const { _getDepositDataFromKeystore } = require('../logic/BLSCredentialGenerator');

class UtilsSubPackage {

	constructor(signer) {
		this.etherSigner = signer;
	}

	checkKeystorePass(password) {
		return _checkKeystorePass(password);
	}

	add0x(data) {
		return _add0x(data);
	}

	remove0x(data) {
		return _remove0x(data);
	}

	getPersonalSignInitials(provider, blsPublicKey, blsSignature, account, typeofWallet=null) {
		return _getPersonalSignInitials(provider, blsPublicKey, blsSignature, account, typeofWallet);
	}

	getBatchPersonalSignInitials(provider, blsPublicKeys, blsSignatures, account, typeofWallet) {
		return _getBatchPersonalSignInitials(provider, blsPublicKeys, blsSignatures, account, typeofWallet);
	}

	getPersonalSignInitialsByPrivateKey(blsPublicKey, blsSignature, privateKey) {
		return _getPersonalSignInitialsByPrivateKey(blsPublicKey, blsSignature, privateKey);
	}

	getBatchPersonalSignInitialsByPrivateKey(blsPublicKeys, blsSignatures, privateKey) {
		return _getBatchPersonalSignInitialsByPrivateKey(blsPublicKeys, blsSignatures, privateKey);
	}

	generateCredentials(password, storage=null) {
		return _generateCredentials(this.etherSigner, password, storage);
	}

	getDepositDataFromKeystore(blsKeystore, password) {
		return _getDepositDataFromKeystore(this.etherSigner, blsKeystore, password);
	}

	getValidatorLifecycleStatus(blsPublicKey) {
		return _getValidatorLifecycleStatus(this.etherSigner, blsPublicKey);
	}

	formDepositDataRoot(blsPublicKey, blsSignature) {
		return _formDepositDataRoot(this.etherSigner, blsPublicKey, blsSignature);
	}

	getLastDepositIndex(blsPublicKey) {
		return _getLastDepositIndex(this.etherSigner, blsPublicKey);
	}

	getDETHBalanceInIndex(blsPublicKey) {
		return _getDETHBalanceInIndex(this.etherSigner, blsPublicKey);
	}

	getSLOTBalanceInVault(stakehouseAddress, userAddress, blsPublicKey) {
		return _getSLOTBalanceInVault(this.etherSigner, stakehouseAddress, userAddress, blsPublicKey);
	}
	
	getsETHAddress(stakehouseAddress) {
		return _getsETHAddress(this.etherSigner, stakehouseAddress);
	}
	
	getsETHBalance(stakehouseAddress, userAddress) {
		return _getsETHBalance(this.etherSigner, stakehouseAddress, userAddress);
	}
	
	getGenericERC20WalletBalance(tokenAddress, userAddress) {
		return _getGenericERC20WalletBalance(this.etherSigner, tokenAddress, userAddress);
	}
	
	currentSlashedAmountOfSLOTForKnot(blsPublicKey) {
		return _currentSlashedAmountOfSLOTForKnot(this.etherSigner, blsPublicKey);
	}
	
	specialExitFee(blsPublicKey) {
		return _specialExitFee(this.etherSigner, blsPublicKey);
	}

	calculateExitFee(authenticatedReport) {
		return _calculateExitFee(this.etherSigner, authenticatedReport);
	}
	
	getNumberOfCollateralisedSlotOwnersForKnot(blsPublicKey) {
		return _getNumberOfCollateralisedSlotOwnersForKnot(this.etherSigner, blsPublicKey);
	}
	
	getStakehouseRedemptionRate(stakehouseAddress) {
		return _getStakehouseRedemptionRate(this.etherSigner, stakehouseAddress);
	}
	
	getStakehouseExchangeRate(stakehouseAddress) {
		return _getStakehouseExchangeRate(this.etherSigner, stakehouseAddress);
	}
	
	getStakehouseSETHRedemptionThreshold(stakehouseAddress) {
		return _getStakehouseSETHRedemptionThreshold(this.etherSigner, stakehouseAddress);
	}
	
	getTotalUserCollateralisedSETHBalanceInHouse(stakehouseAddress, userAddress) {
		return _getTotalUserCollateralisedSETHBalanceInHouse(this.etherSigner, stakehouseAddress, userAddress);
	}
	
	totalFundsInKNOTQueue(blsPublicKey) {
		return _totalFundsInKNOTQueue(this.etherSigner, blsPublicKey);
	}
	
	associatedIndexIdForKnot(blsPublicKey) {
		return _associatedIndexIdForKnot(this.etherSigner, blsPublicKey);
	}
	
	rageQuitChecks(stakehouseAddress, userAddress, authenticatedReport) {
		return _rageQuitChecks(this.etherSigner, stakehouseAddress, userAddress, authenticatedReport);
	}
	
	indexIdToOwner(indexID) {
		return _indexIdToOwner(this.etherSigner, indexID);
	}
	
	isBalanceLower(beaconNodeURL, blsPublicKey) {
		return _isBalanceLower(this.etherSigner, beaconNodeURL, blsPublicKey);
	}
	
	dETHToSavETH(amount) {
		return _dETHToSavETH(this.etherSigner, amount);
	}
	
	savETHToDETH(amount) {
		return _savETHToDETH(this.etherSigner, amount);
	}
	
	dETHRewardsMintedForKNOT(blsPublicKey) {
		return _dETHRewardsMintedForKNOT(this.etherSigner, blsPublicKey);
	}
	
	dETHRequiredForIsolation(blsPublicKey) {
		return _dETHRequiredForIsolation(this.etherSigner, blsPublicKey);
	}
	
	savETHRequiredForIsolation(blsPublicKey) {
		return _savETHRequiredForIsolation(this.etherSigner, blsPublicKey);
	}
	
	getKNOTNonce(blsPublicKey) {
		return _getKNOTNonce(this.etherSigner, blsPublicKey);
	}
	
	getLastKnownReportForKNOT(blsPublicKey) {
		return _getLastKnownReportForKNOT(this.etherSigner, blsPublicKey);
	}
	
	updateSavETHIndexName(indexID, name) {
		return _updateSavETHIndexName(this.etherSigner, indexID, name);
	}
	
	topUpSlashedSlot(stakehouseAddress, blsPublicKey, recipient, amount, ethValue) {
		return _topUpSlashedSlot(this.etherSigner, stakehouseAddress, blsPublicKey, recipient, amount, ethValue);
	}
	
	topUpSlashedSlotWithOneEth(stakehouseAddress, blsPublicKey, recipient) {
		return _topUpSlashedSlotWithOneEth(this.etherSigner, stakehouseAddress, blsPublicKey, recipient);
	}
	
	topUpKNOT(blsPublicKey, ethValue) {
		return _topUpKNOT(this.etherSigner, blsPublicKey, ethValue);
	}
	
	topUpKNOTWithOneEth(blsPublicKey) {
		return _topUpKNOTWithOneEth(this.etherSigner, blsPublicKey);
	}
  
	dETHMetadata() {
		return _dETHMetadata(this.etherSigner);
	}

	getStakehouse(blsPublicKey) {
		return _getStakehouse(this.etherSigner, blsPublicKey);
	}

	isPartOfStakehouse(blsPublicKey) {
		return _isPartOfStakehouse(this.etherSigner, blsPublicKey);
	}
}

module.exports = {
    UtilsSubPackage
};
